module.exports = __webpack_public_path__ + "static/img/item4.73bb425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item4.png
// module id = hdqP
// module chunks = 0